@if (showActionNav) {
<div class="container-item">

  <a class="btn-nav" routerLink="/minhas-compras">
    <div class="icon">
      <span class="material-symbols-outlined">shopping_cart</span>
    </div>
    <label>Minhas compras</label>
  </a>

  <a class="btn-nav" routerLink="/novo-livro">
    <div class="icon">
      <span class="material-symbols-outlined">auto_stories</span>
    </div>
    <label>Publicar meu livro</label>
  </a>

  <a class="btn-nav" routerLink="/meus-livros">
    <div class="icon">
      <span class="material-symbols-outlined">shelves</span>
    </div>
    <label>Meus livros</label>
  </a>

  <a class="btn-nav" routerLink="/config">
    <div class="icon">
      <span class="material-symbols-outlined">settings</span>
    </div>
    <label>Configuração</label>
  </a>

  <a class="btn-nav" routerLink="/carteira">
    <div class="icon">
      <span class="material-symbols-outlined">wallet</span>
    </div>
    <label>Carteira</label>
  </a>

  @if (adminMenu) {
  <div class="btn-nav-admin-hr">
    <div class="internal">
      <hr style="width: 30%;" />
      <span style="width: 30%;">Admin</span>
      <hr style="width: 30%;" />
    </div>
  </div>

  <a class="btn-nav-admin" *ngIf="userMenu" routerLink="/lista-usuarios-admin">
    <div class="icon">
      <span class="material-symbols-outlined">group</span>
    </div>
    <label>Rel. Usuários</label>
  </a>

  <a class="btn-nav-admin" *ngIf="userMenu" routerLink="/usuarios-admin">
    <div class="icon">
      <span class="material-symbols-outlined">admin_panel_settings</span>
    </div>
    <label>Usuários admin</label>
  </a>

  <a class="btn-nav-admin" *ngIf="salesMenu" routerLink="/vendas-admin">
    <div class="icon">
      <span class="material-symbols-outlined">point_of_sale</span>
    </div>
    <label>Vendas</label>
  </a>

  <a class="btn-nav-admin" *ngIf="finMenu" routerLink="/financeiro-admin">
    <div class="icon">
      <span class="material-symbols-outlined">request_quote</span>
    </div>
    <label>Financeiro</label>
  </a>

  <a class="btn-nav-admin" *ngIf="supplierMenu" routerLink="/grafica-admin">
    <div class="icon">
      <span class="material-symbols-outlined">local_shipping</span>
    </div>
    <label>Gráfica</label>
  </a>

  <a class="btn-nav-admin" *ngIf="reviewMenu" routerLink="/revisor">
    <div class="icon">
      <span class="material-symbols-outlined">supervisor_account</span>
    </div>
    <label>Revisores</label>
  </a>

  <a class="btn-nav-admin" *ngIf="publicationMenu" routerLink="/publicar">
    <div class="icon">
      <span class="material-symbols-outlined">wand_stars</span>
    </div>
    <label>Publicar</label>
  </a>

  <a class="btn-nav-admin" *ngIf="editorMenu" routerLink="/editor-admin">
    <div class="icon">
      <span class="material-symbols-outlined">edit_note</span>
    </div>
    <label>Editor de livros</label>
  </a>
  }
</div>

<div class="container-out" (click)="clickContainerOut()"></div>
}